// import { useState, useEffect, useCallback, useMemo, useContext } from "react";
// import { fetchWeeklyReport, getWeeklyMaster } from "../services/forecastService";
// import { reshapeMonthlyStockData, reshapeStockData, reshapeWeeklyStockData, transformDriversData, transformInputsData } from "../utils/reShapingStructures";
// import generateWeeklyRanges from "../utils/generateWeeklyRanges";
// import getCurrentWeekNumFromWeeklyTable from "../utils/getCurrentWeekNumFromWeeklyTable";
// import { HORIZON } from "../utils/config";
// import { AppContext } from "../contexts/AppContext";

// /**
//  * useFetchWeeklyReport
//  * - returns the exact same shape and keys as before
//  * - converts certain driver arrays from percentages (e.g. 10) to fraction (e.g. 0.1)
//  * - does NOT rename keys or mutate original `data`
//  * - conversion is local to this hook so UI consumers get correct fractional values
//  */
// export default function useFetchWeeklyReport(modelCode) {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [weekMasterData, setWeekMasterData] = useState(null);

//     const { versionWeekNo } = useContext(AppContext);

//     const load = useCallback(async () => {
//         if (!modelCode) return;
//         setLoading(true);
//         setError(null);
//         try {
//             const doc = await fetchWeeklyReport(modelCode);
//             console.log("Fetched all datas(weekly_report)", doc);
//             setData(doc);
//         } catch (err) {
//             setError(err);
//         } finally {
//             setLoading(false);
//         }
//     }, [modelCode]);

//     // initial + whenever modelCode changes
//     useEffect(() => {
//         load();
//     }, [load]);

//     useEffect(() => {
//         async function fetchMaster() {
//             try {
//                 const result = await getWeeklyMaster();
//                 setWeekMasterData(result);
//             } catch (err) {
//                 console.error("Error fetching week master data:", err);
//             }
//         }
//         fetchMaster();
//     }, []);


//     const {
//         forecastData,
//         weeklyData,
//         stockMonthlyData,
//         stockWeeklyData,
//         driversMonthlyData,
//         driversWeeklyData,
//         inputsMonthlyData,
//         inputsWeeklyData,
//         allDefaultInputVals,
//         foreCastTertiaryMonthlyData,
//         foreCastTertiaryWeeklyData,
//         pastForecast,       // ← unchanged naming
//         projectedValues,    // ← unchanged naming
//         pastActualsMonthlyAggregation,
//         pastForecastMonthlyAggregation,
//         projectedMonthlyAggregation,
//         aggregations_union_arr,
//         currentWeekNumber,
//         pastActualsEnd,
//         pastActualsCount,
//         forecastCount,
//         projectionCount,
//         finalWeek,
//         weeklyRanges,
//         week_after_launch
//     } = useMemo(() => {
//         // when no data, return same shape as before (safe defaults)
//         if (!data) return {
//             forecastData: {},
//             weeklyData: {},
//             stockMonthlyData: [],
//             stockWeeklyData: [],
//             driversMonthlyData: {},
//             driversWeeklyData: {},
//             inputsMonthlyData: {},
//             inputsWeeklyData: {},
//             allDefaultInputVals: {},
//             foreCastTertiaryMonthlyData: { monthly: [] },
//             foreCastTertiaryWeeklyData: { weekly: [] },
//             pastForecast: { kpis: [], stock: [], drivers: [], exposure: [], input: [] },
//             projected: { kpis: [], stock: [], drivers: [], exposure: [], input: [] },
//             currentWeekNumber: 0,
//             pastActualsEnd: 0,
//             pastActualsCount: 0,
//             forecastCount: 0,
//             projectionCount: 0,
//             finalWeek: 0,
//             weeklyRanges: {},
//             week_after_launch: []
//         };

//         console.log("selected weekno for version:", versionWeekNo)
//         // helper: current week, forecast/projection range calculations
//         const realCurrWeek = getCurrentWeekNumFromWeeklyTable(weekMasterData);
//         const currentWeek = versionWeekNo != null ? versionWeekNo : realCurrWeek;
//         const forecastStart = currentWeek;
//         const forecastEnd = Math.min(
//             currentWeek + HORIZON,
//             Math.max(...(weekMasterData || []).map((d) => d.wk_no))
//         );
//         const projectionStart = forecastEnd + 1;
//         const finalWeek = projectionStart + HORIZON - 1;

//         const pastActualsEnd = Math.max(0, currentWeek - 1);
//         const pastActualsCount = pastActualsEnd;

//         const forecastCount = Math.max(0, forecastEnd - forecastStart + 1);
//         const projectionCount = Math.max(0, finalWeek - projectionStart + 1);

//         const weeklyRanges = generateWeeklyRanges(weekMasterData || []);
//         console.log("From useFetch", currentWeek, forecastStart, forecastEnd, projectionStart, finalWeek, pastActualsEnd, pastActualsCount, forecastCount, projectionCount, weeklyRanges)

//         // Version Week Selected
//         const shift = (versionWeekNo != null) ? (realCurrWeek - versionWeekNo) : 0;
//         const shiftSafe = Math.max(0, Math.floor(shift || 0))
//         console.log("week shift", shift, shiftSafe);

//         // method to safely slice the extra weeks values comming
//         function sliceTrailing(arr, cut) {
//             if (!Array.isArray(arr)) return arr;
//             if (cut <= 0) return arr.slice();
//             const newLen = Math.max(0, arr.length - cut);
//             return arr.slice(0, newLen);
//         }

//         // past actual KPI arrays
//         const forecastData = {
//             primary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "primary")?.val || [],
//             secondary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "secondary")?.val || [],
//             tertiary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "tertiary")?.val || []
//         };
//         const weeklyData = {
//             primary: sliceTrailing((data.past_actuals?.weekly?.kpis?.find(k => k.input_name === "primary")?.val || []), shiftSafe),
//             secondary: sliceTrailing((data.past_actuals?.weekly?.kpis?.find(k => k.input_name === "secondary")?.val || []), shiftSafe),
//             tertiary: sliceTrailing((data.past_actuals?.weekly?.kpis?.find(k => k.input_name === "tertiary")?.val || []), shiftSafe)
//         };

//         // stock reshaping
//         const stockMonthlyData = reshapeMonthlyStockData(data.past_actuals?.monthly?.stock);
//         const stockWeeklyData = reshapeWeeklyStockData((data.past_actuals?.weekly?.stock || []).map(item => ({
//             ...item,
//             val: sliceTrailing(item.val, shiftSafe)
//         })));

//         // drivers (raw transformed objects)
//         const driversMonthlyDataRaw = transformDriversData(data.past_actuals?.monthly?.drivers || []);
//         const driversWeeklyDataRaw = transformDriversData((data.past_actuals?.weekly?.drivers || []).map(item => ({
//             ...item,
//             val: sliceTrailing(item.val, shiftSafe)
//         })));

//         // --- local percent conversion helpers (non-mutating) ---
//         const convertPercentArray = (arr) => {
//             if (!Array.isArray(arr)) return arr;
//             return arr.map(v => {
//                 if (v === null || v === undefined) return v;

//                 const num = typeof v === 'number'
//                     ? v
//                     : (typeof v === 'string' ? Number(v.replace?.("", "")) : NaN);

//                 if (!Number.isFinite(num)) return v;

//                 // If exactly 0, return plain 0
//                 if (num === 0) return 0;

//                 return `${(num * 100).toFixed(2)}`;
//             });
//         };


//         // keys intended to be treated as percentages (exact names from fetched data + variants)
//         const percentKeys = [
//             "ao_per_so", "ao_so",
//             "wod_per_ao", "wod_ao", "wod",
//             "thruput", "throughput",
//         ];

//         const applyPercentFixToDrivers = (driversObj) => {
//             if (!driversObj || typeof driversObj !== 'object') return driversObj;
//             // shallow clone and replace arrays for matching keys only
//             const out = { ...driversObj };
//             percentKeys.forEach(k => {
//                 if (Object.prototype.hasOwnProperty.call(out, k) && Array.isArray(out[k])) {
//                     out[k] = convertPercentArray(out[k]);
//                 }
//             });
//             return out;
//         };
//         // -------------------------------------------------------

//         // apply conversion to drivers (without mutating original transformed objects)
//         const driversMonthlyDataAdj = applyPercentFixToDrivers(driversMonthlyDataRaw);
//         const driversWeeklyDataAdj = applyPercentFixToDrivers(driversWeeklyDataRaw);

//         const inputsMonthlyData = transformInputsData(data?.past_actuals?.monthly?.input || []);
//         const inputsWeeklyData = transformInputsData((data?.past_actuals?.weekly?.input || []).map(item => ({
//             ...item,
//             val: sliceTrailing(item.val, shiftSafe)
//         })));

//         const allDefaultInputVals = {
//             past_forecast: (data.past_forecast?.input || []).reduce((acc, { input_name, val }) => {
//                 acc[input_name] = val;
//                 return acc;
//             }, {}),
//             projected_forecast: (data.projected?.input || []).reduce((acc, { input_name, val }) => {
//                 acc[input_name] = val;
//                 return acc;
//             }, {}),
//         };

//         const foreCastTertiaryMonthlyData = data.past_actuals?.monthly?.forecast_tertiary?.[0]?.val || [];
//         const foreCastTertiaryWeeklyData = sliceTrailing(data.past_actuals?.weekly?.forecast_tertiary[0].val || [], shiftSafe)

//         const spliceIndex = 12 + finalWeek - 1;
//         const spliceVal = 70 - spliceIndex;
//         const week_after_launch = data.week_after_launch;
//         // const week_after_launch = data.week_after_launch.slice(0, -spliceVal);

//         console.log("week_after_launch", week_after_launch, finalWeek, spliceIndex, spliceVal);

//         const aggregations_union_arr = data.aggregations_union_arr;

//         // 5) past_forecast (raw)
//         const pastForecastRaw = {
//             kpi: {
//                 forecasted_tertiary: data?.past_forecast?.kpis?.find(i => i.input_name === "tertiary")?.val || [],
//                 forecasted_secondary: data?.past_forecast?.kpis?.find(i => i.input_name === "secondary")?.val || [],
//                 forecasted_primary: data?.past_forecast?.kpis?.find(i => i.input_name === "primary")?.val || []
//             },
//             stock: {
//                 opening_dbr_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_dbr_stk")?.val || [],
//                 opening_retailer_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_retailer_stk")?.val || [],
//                 opening_market_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_market_stk")?.val || [],
//                 dbr_stock_vol: data.past_forecast?.stock?.find(i => i.input_name === "dbr_stock_vol")?.val || [],
//                 ret_stock_vol: data.past_forecast?.stock?.find(i => i.input_name === "ret_stock_vol")?.val || [],
//                 market_stock: data.past_forecast?.stock?.find(i => i.input_name === "market_stock")?.val || [],
//                 market_dos: data.past_forecast?.stock?.find(i => i.input_name === "market_dos")?.val || []
//             },
//             forecast_tertiary: {
//                 parameters: data.past_forecast?.forecasted_tertiary?.find(i => i.input_name === "parameters")?.val || [],
//                 pilot: data.past_forecast?.forecast_tertiary?.find(i => i.input_name === "pilot")?.val || [],
//                 national: data.past_forecast?.forecast_tertiary?.find(i => i.input_name === "national")?.val || [],
//                 activating_outlet: data.past_forecast?.forecasted_tertiary?.find(i => i.input_name === "activating_outlet")?.val || []
//             },
//             drivers: {
//                 stock_per_outlet: data.past_forecast?.drivers?.find(i => i.input_name === "stock_outlet")?.val || [],
//                 ao_per_so: data.past_forecast?.drivers?.find(i => i.input_name === "ao_so")?.val || [],
//                 throughput: data.past_forecast?.drivers?.find(i => i.input_name === "throughput")?.val || [],
//                 wod_per_ao: data.past_forecast?.drivers?.find(i => i.input_name === "wod_ao")?.val || [],
//                 tput: data.past_forecast?.drivers?.find(i => i.input_name === "tput")?.val || [],
//                 pilot_l7d_sum: data.past_forecast?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_sum")?.val || [],
//                 pilot_l7_davg: data.past_forecast?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_avg")?.val || [],
//                 national_l7drr: data.past_forecast?.drivers?.find(i => i.input_name === "national_l7_drr")?.val || [],
//                 week_after_launch: data.past_forecast?.drivers?.find(i => i.input_name === "week_after_launch")?.val || []
//             },
//             exposure: {
//                 exposure: data.past_forecast?.exposure?.find(i => i.input_name === "exposure")?.val || [],
//                 exposure_dos: data.past_forecast?.exposure?.find(i => i.input_name === "exposure_dos")?.val || []
//             },
//             input: {
//                 dbr_dos: data.past_forecast?.input?.find(i => i.input_name === "dbr_dos")?.val || [],
//                 ret_dos: data.past_forecast?.input?.find(i => i.input_name === "ret_dos")?.val || [],
//                 wod: data.past_forecast?.input?.find(i => i.input_name === "wod")?.val || [],
//                 plc_factor: data.past_forecast?.input?.find(i => i.input_name === "plc_factor")?.val || [],
//                 seasonality: data.past_forecast?.input?.find(i => i.input_name === "seasonality")?.val || [],
//                 pilot_weightage: data.past_forecast?.input?.find(i => i.input_name === "pilot_weightage")?.val || [],
//                 national_weightage: data.past_forecast?.input?.find(i => i.input_name === "national_weightage")?.val || [],
//                 parameters_weightage: data.past_forecast?.input?.find(i => i.input_name === "parameters_weightage")?.val || [],
//                 stocking_outlet: data.past_forecast?.input?.find(i => i.input_name === "stocking_outlet")?.val || [],
//                 activating_outlet: data.past_forecast?.input?.find(i => i.input_name === "activating_outlet")?.val || [],
//             },
//         };

//         // apply percent conversion only to drivers inside pastForecast (non-mutating)
//         const pastForecast = {
//             ...pastForecastRaw,
//             drivers: applyPercentFixToDrivers(pastForecastRaw.drivers)
//         };

//         // 6) projections (raw)
//         const projectedValuesRaw = {
//             kpi: {
//                 tertiary: data.projected?.kpis?.find(i => i.input_name === "tertiary")?.val || [],
//                 secondary: data.projected?.kpis?.find(i => i.input_name === "secondary")?.val || [],
//                 primary: data.projected?.kpis?.find(i => i.input_name === "primary")?.val || []
//             },
//             stock: {
//                 opening_dbr_stk: data.projected?.stock?.find(i => i.input_name === "opening_dbr_stk")?.val || [],
//                 opening_retailer_stk: data.projected?.stock?.find(i => i.input_name === "opening_retailer_stk")?.val || [],
//                 opening_market_stk: data.projected?.stock?.find(i => i.input_name === "opening_market_stk")?.val || [],
//                 dbr_stock_vol: data.projected?.stock?.find(i => i.input_name === "dbr_stock_vol")?.val || [],
//                 ret_stock_vol: data.projected?.stock?.find(i => i.input_name === "ret_stock_vol")?.val || [],
//                 market_stock: data.projected?.stock?.find(i => i.input_name === "market_stock")?.val || [],
//                 market_dos: data.projected?.stock?.find(i => i.input_name === "market_dos")?.val || []
//             },
//             forecast_tertiary: {
//                 parameters: data.projected?.forecast_tertiary?.find(i => i.input_name === "parameters")?.val || [],
//                 pilot: data.projected?.forecast_tertiary?.find(i => i.input_name === "pilot")?.val || [],
//                 national: data.projected?.forecast_tertiary?.find(i => i.input_name === "national")?.val || [],
//                 activating_outlet: data.projected?.forecast_tertiary?.find(i => i.input_name === "activating_outlet")?.val || []
//             },
//             drivers: {
//                 stock_outlet: data.projected?.drivers?.find(i => i.input_name === "stock_outlet")?.val || [],
//                 ao_per_so: data.projected?.drivers?.find(i => i.input_name === "ao_per_so")?.val || [],
//                 throughput: data.projected?.drivers?.find(i => i.input_name === "throughput")?.val || [],
//                 wod_ao: data.projected?.drivers?.find(i => i.input_name === "wod_ao")?.val || [],
//                 tput: data.projected?.drivers?.find(i => i.input_name === "tput")?.val || [],
//                 pilot_tertiary_l7d_sum: data.projected?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_sum")?.val || [],
//                 pilot_tertiary_l7d_avg: data.projected?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_avg")?.val || [],
//                 national_l7_drr: data.projected?.drivers?.find(i => i.input_name === "national_l7_drr")?.val || [],
//                 week_after_launch: data.projected?.drivers?.find(i => i.input_name === "week_after_launch")?.val || []
//             },
//             exposure: {
//                 exposure: data.projected?.exposure?.find(i => i.input_name === "exposure")?.val || [],
//                 exposure_dos: data.projected?.exposure?.find(i => i.input_name === "exposure_dos")?.val || []
//             },
//             input: {
//                 dbr_dos: data.projected?.input?.find(i => i.input_name === "dbr_dos")?.val || [],
//                 ret_dos: data.projected?.input?.find(i => i.input_name === "ret_dos")?.val || [],
//                 wod: data.projected?.input?.find(i => i.input_name === "wod")?.val || [],
//                 plc_factor: data.projected?.input?.find(i => i.input_name === "plc_factor")?.val || [],
//                 seasonality: data.projected?.input?.find(i => i.input_name === "seasonality")?.val || [],
//                 pilot_weightage: data.projected?.input?.find(i => i.input_name === "pilot_weightage")?.val || [],
//                 national_weightage: data.projected?.input?.find(i => i.input_name === "national_weightage")?.val || [],
//                 parameters_weightage: data.projected?.input?.find(i => i.input_name === "parameters_weightage")?.val || [],
//                 stocking_outlet: data.projected?.input?.find(i => i.input_name === "stocking_outlet")?.val || [],
//                 activating_outlet: data.projected?.input?.find(i => i.input_name === "activating_outlet")?.val || [],
//             },
//         };

//         // apply percent conversion only to drivers inside projectedValues (non-mutating)
//         const projectedValues = {
//             ...projectedValuesRaw,
//             drivers: applyPercentFixToDrivers(projectedValuesRaw.drivers)
//         };

//         // --- monthly aggregation objects coming from backend (new) ---
//         const pastActualsMonthlyAggregation = data?.past_actuals?.monthly_aggregation || null;
//         const pastForecastMonthlyAggregation = data?.past_forecast?.monthly_aggregation || null;
//         const projectedMonthlyAggregation = data?.projected?.monthly_aggregation || null;

//         // -------------------------------------------------------------


//         // return everything exactly with original naming
//         return {
//             forecastData,
//             weeklyData,
//             stockMonthlyData,
//             stockWeeklyData,
//             driversMonthlyData: driversMonthlyDataAdj,
//             driversWeeklyData: driversWeeklyDataAdj,
//             inputsMonthlyData,
//             inputsWeeklyData,
//             allDefaultInputVals,
//             foreCastTertiaryMonthlyData,
//             foreCastTertiaryWeeklyData,
//             pastForecast,
//             projectedValues,

//             pastActualsMonthlyAggregation,
//             pastForecastMonthlyAggregation,
//             projectedMonthlyAggregation,
//             aggregations_union_arr,

//             currentWeekNumber: currentWeek,
//             pastActualsEnd,
//             pastActualsCount,
//             forecastCount,
//             projectionCount,
//             finalWeek,
//             weeklyRanges,
//             week_after_launch
//         };
//     }, [data, weekMasterData, versionWeekNo]);

//     return {
//         forecastData,
//         weeklyData,
//         stockMonthlyData,
//         stockWeeklyData,
//         driversMonthlyData,
//         driversWeeklyData,
//         inputsMonthlyData,
//         inputsWeeklyData,
//         allDefaultInputVals,
//         foreCastTertiaryMonthlyData,
//         foreCastTertiaryWeeklyData,
//         aggregations_union_arr,

//         pastForecast,
//         projectedValues,

//         pastActualsMonthlyAggregation,
//         pastForecastMonthlyAggregation,
//         projectedMonthlyAggregation,

//         currentWeekNumber,
//         pastActualsEnd,
//         pastActualsCount,
//         forecastCount,
//         projectionCount,
//         finalWeek,
//         weeklyRanges,
//         week_after_launch,
//         /* standard controls */
//         loading,
//         error,
//         refetch: load
//     };
// }



import { useState, useEffect, useCallback, useMemo, useContext } from "react";
import { fetchWeeklyReport, getWeeklyMaster } from "../services/forecastService";
import { reshapeMonthlyStockData, reshapeWeeklyStockData, transformDriversData, transformInputsData } from "../utils/reShapingStructures";
import generateWeeklyRanges from "../utils/generateWeeklyRanges";
import getCurrentWeekNumFromWeeklyTable from "../utils/getCurrentWeekNumFromWeeklyTable";
import { HORIZON } from "../utils/config";
import { AppContext } from "../contexts/AppContext";
// NEW import used to derive last-week indices for months

/**
 * useFetchWeeklyReport
 * - returns the exact same shape and keys as before
 * - converts certain driver arrays from percentages (e.g. 10) to fraction (e.g. 0.1)
 * - does NOT rename keys or mutate original `data`
 * - conversion is local to this hook so UI consumers get correct fractional values
 */
export default function useFetchWeeklyReport(modelCode) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [weekMasterData, setWeekMasterData] = useState(null);

    const { versionWeekNo } = useContext(AppContext);

    const load = useCallback(async () => {
        if (!modelCode) return;
        setLoading(true);
        setError(null);
        try {
            const doc = await fetchWeeklyReport(modelCode);
            console.log("Fetched all datas(weekly_report)", doc);
            setData(doc);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [modelCode]);

    // initial + whenever modelCode changes
    useEffect(() => {
        load();
    }, [load]);

    useEffect(() => {
        async function fetchMaster() {
            try {
                const result = await getWeeklyMaster();
                setWeekMasterData(result);
            } catch (err) {
                console.error("Error fetching week master data:", err);
            }
        }
        fetchMaster();
    }, []);


    const {
        forecastData,
        weeklyData,
        stockMonthlyData,
        stockWeeklyData,
        driversMonthlyData,
        driversWeeklyData,
        inputsMonthlyData,
        inputsWeeklyData,
        allDefaultInputVals,
        foreCastTertiaryMonthlyData,
        foreCastTertiaryWeeklyData,
        pastForecast,       // ← unchanged naming
        projectedValues,    // ← unchanged naming
        pastActualsMonthlyAggregation,
        pastForecastMonthlyAggregation,
        projectedMonthlyAggregation,
        aggregations_union_arr,
        currentWeekNumber,
        pastActualsEnd,
        pastActualsCount,
        forecastCount,
        projectionCount,
        finalWeek,
        weeklyRanges,
        week_after_launch
    } = useMemo(() => {
        // when no data, return same shape as before (safe defaults)
        if (!data) return {
            forecastData: {},
            weeklyData: {},
            stockMonthlyData: [],
            stockWeeklyData: [],
            driversMonthlyData: {},
            driversWeeklyData: {},
            inputsMonthlyData: {},
            inputsWeeklyData: {},
            allDefaultInputVals: {},
            foreCastTertiaryMonthlyData: { monthly: [] },
            foreCastTertiaryWeeklyData: { weekly: [] },
            pastForecast: { kpis: [], stock: [], drivers: [], exposure: [], input: [] },
            projected: { kpis: [], stock: [], drivers: [], exposure: [], input: [] },
            currentWeekNumber: 0,
            pastActualsEnd: 0,
            pastActualsCount: 0,
            forecastCount: 0,
            projectionCount: 0,
            finalWeek: 0,
            weeklyRanges: {},
            week_after_launch: []
        };

        console.log("selected weekno for version:", versionWeekNo)
        // helper: current week, forecast/projection range calculations
        const realCurrWeek = getCurrentWeekNumFromWeeklyTable(weekMasterData);
        const currentWeek = versionWeekNo != null ? versionWeekNo : realCurrWeek;
        const forecastStart = currentWeek;
        const forecastEnd = Math.min(
            currentWeek + HORIZON,
            Math.max(...(weekMasterData || []).map((d) => d.wk_no))
        );
        const projectionStart = forecastEnd + 1;
        const finalWeek = projectionStart + HORIZON - 1;

        const pastActualsEnd = Math.max(0, currentWeek - 1);
        const pastActualsCount = pastActualsEnd;

        const forecastCount = Math.max(0, data?.past_forecast?.kpis?.[0]?.val?.length || 0);

        const projectionCount = Math.max(0, finalWeek - projectionStart + 1);

        // Version Week Selected
        const shift = (versionWeekNo != null) ? (realCurrWeek - versionWeekNo) : 0;
        const shiftSafe = Math.max(0, Math.floor(shift || 0))
        console.log("week shift", shift, shiftSafe);

        const weeklyRangesFull = generateWeeklyRanges(weekMasterData || []);
        const weeklyRanges = sliceTrailing(weeklyRangesFull, shiftSafe);
        console.log("From useFetch", currentWeek, forecastStart, forecastEnd, projectionStart, finalWeek, pastActualsEnd, pastActualsCount, forecastCount, projectionCount, weeklyRanges)



        // method to safely slice the extra weeks values comming
        function sliceTrailing(arr, cut) {
            if (!Array.isArray(arr)) return arr;
            if (cut <= 0) return arr.slice();
            const newLen = Math.max(0, arr.length - cut);
            return arr.slice(0, newLen);
        }

        // ----------------- SLICE ALL past_actuals.weekly STRUCTURES -----------------
        const pastWeeklyRaw = data.past_actuals?.weekly || {};

        const keysToSlice = ['kpis', 'stock', 'drivers', 'exposure', 'forecast_tertiary', 'input'];

        const pastWeeklySliced = {};
        keysToSlice.forEach(k => {
            const arr = Array.isArray(pastWeeklyRaw[k]) ? pastWeeklyRaw[k] : [];
            pastWeeklySliced[k] = arr.map(item => {
                // item may be an object { input_name, val } OR could be a plain array in some shapes
                if (!item || typeof item !== 'object') {
                    // treat as array-of-values (defensive)
                    return sliceTrailing(item, shiftSafe);
                }
                return {
                    ...item,
                    val: sliceTrailing(Array.isArray(item.val) ? item.val : [], shiftSafe)
                };
            });
        });
        // --------------------------------------------------------------------------

        // past actual KPI arrays (monthly unchanged, weekly now from sliced)
        const forecastData = {
            primary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "primary")?.val || [],
            secondary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "secondary")?.val || [],
            tertiary: data.past_actuals?.monthly?.kpis?.find(k => k.input_name === "tertiary")?.val || []
        };
        const weeklyData = {
            primary: pastWeeklySliced.kpis?.find(k => k.input_name === "primary")?.val || [],
            secondary: pastWeeklySliced.kpis?.find(k => k.input_name === "secondary")?.val || [],
            tertiary: pastWeeklySliced.kpis?.find(k => k.input_name === "tertiary")?.val || []
        };

        // stock reshaping (use sliced weekly stock)
        const stockMonthlyData = reshapeMonthlyStockData(data.past_actuals?.monthly?.stock);
        const stockWeeklyData = reshapeWeeklyStockData(pastWeeklySliced.stock || []);

        // drivers (raw transformed objects using sliced weekly)
        const driversMonthlyDataRaw = transformDriversData(data.past_actuals?.monthly?.drivers || []);
        // transformDriversData expects input in a particular shape; provide the sliced array
        const driversWeeklyDataRaw = transformDriversData(pastWeeklySliced.drivers || []);

        // --- local percent conversion helpers (non-mutating) ---
        const convertPercentArray = (arr) => {
            if (!Array.isArray(arr)) return arr;
            return arr.map(v => {
                if (v === null || v === undefined) return v;

                const num = typeof v === 'number'
                    ? v
                    : (typeof v === 'string' ? Number(v.replace?.("", "")) : NaN);

                if (!Number.isFinite(num)) return v;

                // If exactly 0, return plain 0
                if (num === 0) return 0;

                return `${(num * 100).toFixed(2)}`;
            });
        };

        const convertDecimalArray = (arr) => {
            if (!Array.isArray(arr)) return arr;
            return arr.map(v => {
                if (v === null || v === undefined) return v;

                const num = typeof v === 'number'
                    ? v
                    : (typeof v === 'string' ? Number(v.replace?.("", "")) : NaN);

                if (!Number.isFinite(num)) return v;

                // If exactly 0, return plain 0
                if (num === 0) return 0;

                return `${(num).toFixed(2)}`;
            });
        };


        // keys intended to be treated as percentages (exact names from fetched data + variants)
        const percentKeys = [
            // "ao_per_so", "ao_so",
            // "wod_per_ao", 
            "wod",
            //"thruput",
            "throughput",
        ];

        const decimalKeys = [
            "stock_per_outlet",
            "tput",
            "wod_per_ao",
            "ao_so", "ao_per_so",
            "wod_ao"
        ];

        const applyPercentFixToDrivers = (driversObj) => {
            if (!driversObj || typeof driversObj !== 'object') return driversObj;
            // shallow clone and replace arrays for matching keys only
            const out = { ...driversObj };
            percentKeys.forEach(k => {
                if (Object.prototype.hasOwnProperty.call(out, k) && Array.isArray(out[k])) {
                    out[k] = convertPercentArray(out[k]);
                }
            });
            decimalKeys.forEach(k => {
                if (Object.prototype.hasOwnProperty.call(out, k) && Array.isArray(out[k])) {
                    out[k] = convertDecimalArray(out[k]);
                }
            });
            return out;
        };
        // -------------------------------------------------------

        // apply conversion to drivers (without mutating original transformed objects)
        const driversMonthlyDataAdj = applyPercentFixToDrivers(driversMonthlyDataRaw);
        const driversWeeklyDataAdj = applyPercentFixToDrivers(driversWeeklyDataRaw);

        const inputsMonthlyData = transformInputsData(data?.past_actuals?.monthly?.input || []);
        const inputsWeeklyData = transformInputsData(pastWeeklySliced.input || []);

        const allDefaultInputVals = {
            past_forecast: (data.past_forecast?.input || []).reduce((acc, { input_name, val }) => {
                acc[input_name] = val;
                return acc;
            }, {}),
            projected_forecast: (data.projected?.input || []).reduce((acc, { input_name, val }) => {
                acc[input_name] = val;
                return acc;
            }, {}),
        };

        const foreCastTertiaryMonthlyData = data.past_actuals?.monthly?.forecast_tertiary?.[0]?.val || [];
        const foreCastTertiaryWeeklyData = (pastWeeklySliced.forecast_tertiary?.[0]?.val) || [];

        const spliceIndex = 12 + finalWeek - 1;
        const spliceVal = 70 - spliceIndex;
        const week_after_launch = data.week_after_launch;
        // const week_after_launch = data.week_after_launch.slice(0, -spliceVal);

        console.log("week_after_launch", week_after_launch, finalWeek, spliceIndex, spliceVal);

        // If we are viewing a historical version (shiftSafe > 0), ignore backend union
        // so the UI will rebuild the union from the (trimmed) section-level monthly_aggregation objects.
        const aggregations_union_arr = (shiftSafe > 0) ? null : data.aggregations_union_arr;


        // 5) past_forecast (raw)
        const pastForecastRaw = {
            kpi: {
                forecasted_tertiary: data?.past_forecast?.kpis?.find(i => i.input_name === "tertiary")?.val || [],
                forecasted_secondary: data?.past_forecast?.kpis?.find(i => i.input_name === "secondary")?.val || [],
                forecasted_primary: data?.past_forecast?.kpis?.find(i => i.input_name === "primary")?.val || []
            },
            stock: {
                opening_dbr_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_dbr_stk")?.val || [],
                opening_retailer_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_retailer_stk")?.val || [],
                opening_market_stock: data.past_forecast?.stock?.find(i => i.input_name === "opening_market_stk")?.val || [],
                dbr_stock_vol: data.past_forecast?.stock?.find(i => i.input_name === "dbr_stock_vol")?.val || [],
                ret_stock_vol: data.past_forecast?.stock?.find(i => i.input_name === "ret_stock_vol")?.val || [],
                market_stock: data.past_forecast?.stock?.find(i => i.input_name === "market_stock")?.val || [],
                market_dos: data.past_forecast?.stock?.find(i => i.input_name === "market_dos")?.val || []
            },
            forecast_tertiary: {
                parameters: data.past_forecast?.forecasted_tertiary?.find(i => i.input_name === "parameters")?.val || [],
                pilot: data.past_forecast?.forecast_tertiary?.find(i => i.input_name === "pilot")?.val || [],
                national: data.past_forecast?.forecast_tertiary?.find(i => i.input_name === "national")?.val || [],
                activating_outlet: data.past_forecast?.forecasted_tertiary?.find(i => i.input_name === "activating_outlet")?.val || []
            },
            drivers: {
                stock_per_outlet: data.past_forecast?.drivers?.find(i => i.input_name === "stock_outlet")?.val || [],
                ao_per_so: data.past_forecast?.drivers?.find(i => i.input_name === "ao_so")?.val || [],
                throughput: data.past_forecast?.drivers?.find(i => i.input_name === "throughput")?.val || [],
                wod_per_ao: data.past_forecast?.drivers?.find(i => i.input_name === "wod_ao")?.val || [],
                tput: data.past_forecast?.drivers?.find(i => i.input_name === "tput")?.val || [],
                pilot_l7d_sum: data.past_forecast?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_sum")?.val || [],
                pilot_l7_davg: data.past_forecast?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_avg")?.val || [],
                national_l7drr: data.past_forecast?.drivers?.find(i => i.input_name === "national_l7_drr")?.val || [],
                week_after_launch: data.past_forecast?.drivers?.find(i => i.input_name === "week_after_launch")?.val || []
            },
            exposure: {
                exposure: data.past_forecast?.exposure?.find(i => i.input_name === "exposure")?.val || [],
                exposure_dos: data.past_forecast?.exposure?.find(i => i.input_name === "exposure_dos")?.val || []
            },
            input: {
                dbr_dos: data.past_forecast?.input?.find(i => i.input_name === "dbr_dos")?.val || [],
                ret_dos: data.past_forecast?.input?.find(i => i.input_name === "ret_dos")?.val || [],
                wod: data.past_forecast?.input?.find(i => i.input_name === "wod")?.val || [],
                plc_factor: data.past_forecast?.input?.find(i => i.input_name === "plc_factor")?.val || [],
                seasonality: data.past_forecast?.input?.find(i => i.input_name === "seasonality")?.val || [],
                pilot_weightage: data.past_forecast?.input?.find(i => i.input_name === "pilot_weightage")?.val || [],
                national_weightage: data.past_forecast?.input?.find(i => i.input_name === "national_weightage")?.val || [],
                parameters_weightage: data.past_forecast?.input?.find(i => i.input_name === "parameters_weightage")?.val || [],
                stocking_outlet: data.past_forecast?.input?.find(i => i.input_name === "stocking_outlet")?.val || [],
                activating_outlet: data.past_forecast?.input?.find(i => i.input_name === "activating_outlet")?.val || [],
            },
        };

        // apply percent conversion only to drivers inside pastForecast (non-mutating)
        const pastForecast = {
            ...pastForecastRaw,
            drivers: applyPercentFixToDrivers(pastForecastRaw.drivers)
        };

        // 6) projections (raw)
        const projectedValuesRaw = {
            kpi: {
                tertiary: data.projected?.kpis?.find(i => i.input_name === "tertiary")?.val || [],
                secondary: data.projected?.kpis?.find(i => i.input_name === "secondary")?.val || [],
                primary: data.projected?.kpis?.find(i => i.input_name === "primary")?.val || []
            },
            stock: {
                opening_dbr_stk: data.projected?.stock?.find(i => i.input_name === "opening_dbr_stk")?.val || [],
                opening_retailer_stk: data.projected?.stock?.find(i => i.input_name === "opening_retailer_stk")?.val || [],
                opening_market_stk: data.projected?.stock?.find(i => i.input_name === "opening_market_stk")?.val || [],
                dbr_stock_vol: data.projected?.stock?.find(i => i.input_name === "dbr_stock_vol")?.val || [],
                ret_stock_vol: data.projected?.stock?.find(i => i.input_name === "ret_stock_vol")?.val || [],
                market_stock: data.projected?.stock?.find(i => i.input_name === "market_stock")?.val || [],
                market_dos: data.projected?.stock?.find(i => i.input_name === "market_dos")?.val || []
            },
            forecast_tertiary: {
                parameters: data.projected?.forecast_tertiary?.find(i => i.input_name === "parameters")?.val || [],
                pilot: data.projected?.forecast_tertiary?.find(i => i.input_name === "pilot")?.val || [],
                national: data.projected?.forecast_tertiary?.find(i => i.input_name === "national")?.val || [],
                activating_outlet: data.projected?.forecast_tertiary?.find(i => i.input_name === "activating_outlet")?.val || []
            },
            drivers: {
                stock_outlet: data.projected?.drivers?.find(i => i.input_name === "stock_outlet")?.val || [],
                ao_so: data.projected?.drivers?.find(i => i.input_name === "ao_so")?.val || [],
                throughput: data.projected?.drivers?.find(i => i.input_name === "throughput")?.val || [],
                wod_ao: data.projected?.drivers?.find(i => i.input_name === "wod_ao")?.val || [],
                tput: data.projected?.drivers?.find(i => i.input_name === "tput")?.val || [],
                pilot_tertiary_l7d_sum: data.projected?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_sum")?.val || [],
                pilot_tertiary_l7d_avg: data.projected?.drivers?.find(i => i.input_name === "pilot_tertiary_l7d_avg")?.val || [],
                national_l7_drr: data.projected?.drivers?.find(i => i.input_name === "national_l7_drr")?.val || [],
                week_after_launch: data.projected?.drivers?.find(i => i.input_name === "week_after_launch")?.val || []
            },
            exposure: {
                exposure: data.projected?.exposure?.find(i => i.input_name === "exposure")?.val || [],
                exposure_dos: data.projected?.exposure?.find(i => i.input_name === "exposure_dos")?.val || []
            },
            input: {
                dbr_dos: data.projected?.input?.find(i => i.input_name === "dbr_dos")?.val || [],
                ret_dos: data.projected?.input?.find(i => i.input_name === "ret_dos")?.val || [],
                wod: data.projected?.input?.find(i => i.input_name === "wod")?.val || [],
                plc_factor: data.projected?.input?.find(i => i.input_name === "plc_factor")?.val || [],
                seasonality: data.projected?.input?.find(i => i.input_name === "seasonality")?.val || [],
                pilot_weightage: data.projected?.input?.find(i => i.input_name === "pilot_weightage")?.val || [],
                national_weightage: data.projected?.input?.find(i => i.input_name === "national_weightage")?.val || [],
                parameters_weightage: data.projected?.input?.find(i => i.input_name === "parameters_weightage")?.val || [],
                stocking_outlet: data.projected?.input?.find(i => i.input_name === "stocking_outlet")?.val || [],
                activating_outlet: data.projected?.input?.find(i => i.input_name === "activating_outlet")?.val || [],
            },
        };

        // apply percent conversion only to drivers inside projectedValues (non-mutating)
        const projectedValues = {
            ...projectedValuesRaw,
            drivers: projectedValuesRaw.drivers
        };

        // --- monthly aggregation objects coming from backend (new) ---
        // We'll trim them so months/vals align with sliced weekly arrays
        const rawPastActualsMonthlyAgg = data?.past_actuals?.monthly_aggregation || null;
        const rawPastForecastMonthlyAgg = data?.past_forecast?.monthly_aggregation || null;
        const rawProjectedMonthlyAgg = data?.projected?.monthly_aggregation || null;

        // helper to trim a monthly_aggregation object to months whose last-week <= allowedLastWeekMax
        // function trimMonthlyAggregationForMaxLastWeek(monthlyAgg, allowedLastWeekMax) {
        //     if (!monthlyAgg || !Array.isArray(monthlyAgg.months)) return monthlyAgg;
        //     // build mapping monthIdx -> lastWeek global index using same weeklyRanges used by UI
        //     let maps = null;
        //     try {
        //         maps = buildMonthLastWeekIndexMap(weeklyRanges || [], monthlyAgg.months || []);
        //     } catch (e) {
        //         console.warn("buildMonthLastWeekIndexMap threw while trimming monthly aggregation:", e);
        //         maps = { monthIdxToLastWeek: [] };
        //     }
        //     const monthIdxToLastWeek = maps?.monthIdxToLastWeek || [];
        //     // determine which month indices to keep
        //     const keepIdxs = [];
        //     for (let idx = 0; idx < monthIdxToLastWeek.length; idx++) {
        //         const lw = monthIdxToLastWeek[idx];
        //         if (lw === null || lw === undefined || Number.isNaN(Number(lw))) continue;
        //         if (lw <= allowedLastWeekMax) keepIdxs.push(idx);
        //     }
        //     if (keepIdxs.length === 0) {
        //         // return a structurally similar but empty aggregation to be safe
        //         const empty = { ...monthlyAgg };
        //         empty.months = [];
        //         // zero-out known sections
        //         ['kpis', 'stocks', 'stock', 'drivers', 'forecast_tertiary', 'exposure', 'input'].forEach(sec => {
        //             if (Array.isArray(empty[sec])) empty[sec] = [];
        //         });
        //         return empty;
        //     }
        //     const pickVals = (arr) => {
        //         if (!Array.isArray(arr)) return arr;
        //         return arr.map(entry => {
        //             if (!entry || !Array.isArray(entry.val)) return entry;
        //             const newVal = keepIdxs.map(i => entry.val[i]);
        //             return { ...entry, val: newVal };
        //         });
        //     };
        //     const out = { ...monthlyAgg };
        //     out.months = keepIdxs.map(i => monthlyAgg.months[i]);
        //     out.kpis = pickVals(monthlyAgg.kpis || []);
        //     // handle both possible names for stock arrays
        //     out.stocks = pickVals(monthlyAgg.stocks || monthlyAgg.stock || []);
        //     if (monthlyAgg.stock) out.stock = pickVals(monthlyAgg.stock || []);
        //     out.drivers = pickVals(monthlyAgg.drivers || []);
        //     out.forecast_tertiary = pickVals(monthlyAgg.forecast_tertiary || []);
        //     out.exposure = pickVals(monthlyAgg.exposure || []);
        //     out.input = pickVals(monthlyAgg.input || []);
        //     return out;
        // }

        // compute valid end indices for each section
        // const pastForecastStart = pastActualsCount || 0;
        // const pastForecastEnd = Math.max(-1, (pastActualsCount || 0) + (forecastCount || 0) - 1);
        // const projectedStartGlobal = (pastActualsCount || 0) + (forecastCount || 0);
        // const projectedEndIndex = Math.max(-1, projectedStartGlobal + (projectionCount || 0) - 1);

        // const pastActualsMonthlyAggregation = trimMonthlyAggregationForMaxLastWeek(rawPastActualsMonthlyAgg, pastActualsEnd);
        // const pastForecastMonthlyAggregation = trimMonthlyAggregationForMaxLastWeek(rawPastForecastMonthlyAgg, pastForecastEnd);
        // const projectedMonthlyAggregation = trimMonthlyAggregationForMaxLastWeek(rawProjectedMonthlyAgg, projectedEndIndex);
        const pastActualsMonthlyAggregation = rawPastActualsMonthlyAgg;
        const pastForecastMonthlyAggregation = rawPastForecastMonthlyAgg;
        const projectedMonthlyAggregation = rawProjectedMonthlyAgg;

        console.log("aggregation objects", pastActualsMonthlyAggregation, pastForecastMonthlyAggregation, projectedMonthlyAggregation);

        // -------------------------------------------------------------


        // return everything exactly with original naming
        return {
            forecastData,
            weeklyData,
            stockMonthlyData,
            stockWeeklyData,
            driversMonthlyData: driversMonthlyDataAdj,
            driversWeeklyData: driversWeeklyDataAdj,
            inputsMonthlyData,
            inputsWeeklyData,
            allDefaultInputVals,
            foreCastTertiaryMonthlyData,
            foreCastTertiaryWeeklyData,
            pastForecast,
            projectedValues,

            pastActualsMonthlyAggregation,
            pastForecastMonthlyAggregation,
            projectedMonthlyAggregation,
            aggregations_union_arr,

            currentWeekNumber: currentWeek,
            pastActualsEnd,
            pastActualsCount,
            forecastCount,
            projectionCount,
            finalWeek,
            weeklyRanges,
            week_after_launch
        };
    }, [data, weekMasterData, versionWeekNo]);

    return {
        forecastData,
        weeklyData,
        stockMonthlyData,
        stockWeeklyData,
        driversMonthlyData,
        driversWeeklyData,
        inputsMonthlyData,
        inputsWeeklyData,
        allDefaultInputVals,
        foreCastTertiaryMonthlyData,
        foreCastTertiaryWeeklyData,
        aggregations_union_arr,

        pastForecast,
        projectedValues,

        pastActualsMonthlyAggregation,
        pastForecastMonthlyAggregation,
        projectedMonthlyAggregation,

        currentWeekNumber,
        pastActualsEnd,
        pastActualsCount,
        forecastCount,
        projectionCount,
        finalWeek,
        weeklyRanges,
        week_after_launch,
        /* standard controls */
        loading,
        error,
        refetch: load
    };
}
